(function () {
  'use strict';
  function initHero() {
  }

  /* ── Global init ──────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initHero();
  });

  // Re-init after Shopify section refreshes in the editor
  document.addEventListener('shopify:section:load', function (e) {
    var type = e.target.dataset.sectionType;
    if (type === 'home-hero') initHero();
  });

})();


document.querySelector('form').addEventListener('submit', function(e) {
  const password = document.getElementById('new-password').value;
  const confirm = document.getElementById('confirm-password').value;

  if (password || confirm) {
    if (password.length < 8) {
      e.preventDefault();
      alert('Password must be at least 8 characters.');
      return;
    }

    if (password !== confirm) {
      e.preventDefault();
      alert('Passwords do not match.');
      return;
    }
  }
});

document.querySelectorAll('.header-menu-list a, .mobile-menu-list a').forEach(link => {
  link.addEventListener('click', function () {

    document.querySelectorAll('.header-menu-list a, .mobile-menu-list a').forEach(item => {
      item.classList.remove('active');
    });

    this.classList.add('active');
  });
});

(function() {
  var el = document.getElementById('customer-days');
  if (!el) return;
  var ts = parseInt(el.getAttribute('data-created'), 10);
  if (!ts) return;
  var diffDays = Math.floor((new Date() - new Date(ts * 1000)) / 86400000);
  el.textContent = diffDays;
})();

(function () {
  var qa2Link = document.getElementById('qa2-appstle-subscription-link');
  var attempts = 0;
  var maxAttempts = 20;

  var poll = setInterval(function () {
  attempts++;
  var placeholder = document.getElementById('appstle-subscription-manage-subscription-button-placeholder');
  var innerLink = placeholder ? placeholder.querySelector('a[href]') : null;

  if (innerLink && innerLink.getAttribute('href')) {
    qa2Link.setAttribute('href', innerLink.getAttribute('href'));
    clearInterval(poll);
  } else if (attempts >= maxAttempts) {
  clearInterval(poll);
  }
  }, 250);
})();